import { computed, ref, toValue } from 'vue';
import { SPORT_LIVE_TV_FILTER_GROUPS } from '@/sport-live-tv/constants';
import { filterSportLiveTvOptions } from '@/sport-live-tv/helpers';
import { useSportLiveTvTranslation } from '@/sport-live-tv/composables/use-sport-live-tv-translation';

export const useSportLiveTvFilterGroups = ({ categories, teams, draft, teamsSearch, onTeamsSearchChange }) => {
  const { t } = useSportLiveTvTranslation();

  const activeGroupKey = ref(null);
  const leaguesSearch = ref('');

  const setLeaguesSearch = (value) => {
    leaguesSearch.value = value;
  };

  const groups = computed(() => [
    {
      key: SPORT_LIVE_TV_FILTER_GROUPS.leagues,
      title: t('leagues'),
      searchPlaceholder: t('searchLeagues'),
      options: filterSportLiveTvOptions(
        toValue(categories).map(({ id, name }) => ({ value: String(id), label: name })),
        leaguesSearch.value
      ),
      selected: toValue(draft).leagues.map(String),
      search: leaguesSearch.value,
      onSearchChange: setLeaguesSearch,
    },
    {
      key: SPORT_LIVE_TV_FILTER_GROUPS.teams,
      title: t('teams'),
      searchPlaceholder: t('searchTeams'),
      options: toValue(teams).map((name) => ({ value: name, label: name })),
      selected: toValue(draft).teams,
      search: toValue(teamsSearch),
      onSearchChange: onTeamsSearchChange,
    },
  ]);

  const activeGroup = computed(() => groups.value.find(({ key }) => key === activeGroupKey.value));

  const openGroup = (key) => {
    activeGroupKey.value = key;
  };

  const closeGroup = () => {
    activeGroupKey.value = null;
  };

  return { groups, activeGroup, openGroup, closeGroup };
};
